//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 29/01/2025
// Version       : 1
// Description   : Tabs menús de tanques
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React, { useState } from "react";
import Navbar from "../../Navbar";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Button, Paper, Dialog } from "@mui/material";

import DisponiblesParaInstalar from "./tabs/disponibles_instalar/DisponiblesParaInstalar";
import Tanques from "./tabs/asignado/Tanques";
import Autoelevadores from "./tabs/autoelevadores/Autoelevadores";
import OtrosTanques from "./tabs/otros/OtrosTanques";

import Addtanque from "./Addtanque";

// ICONOS
import PropaneIcon from "@mui/icons-material/Propane";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingIcon from "@mui/icons-material/Pending";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";

function TabsTanques() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // ==============================================================
  // AGREGO UNA CLAVE CUYA UNICA FUNCION ES QUE AL CAMBIAR ACTUALICE LA TABLA
  // clave para forzar refresh en DisponiblesParaInstalar
  const [refreshDisponiblesKey, setRefreshDisponiblesKey] = useState(0);

  // Función para actualizar los tanques luego de guardar (ahora solo incrementa la key)
  const handleTanqueGuardado = () => {
    setRefreshDisponiblesKey((k) => k + 1);
  };

  // ==============================================================

  // DIALOG PARA AGREGAR TANQUES
  const [dialogAgregar, setDialogAgregar] = useState(false);

  // Abrir diálogo
  const handleOpenAgregarTanque = () => {
    setDialogAgregar(true);
  };

  // Cerrar diálogo
  const handleCloseAgregarTanque = () => {
    setDialogAgregar(false);
  };

  // ==============================================================

  return (
    <>
      <Navbar />
      <Paper sx={{ width: "100%", mt: 0.8, boxShadow: "none" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "primary.main",
          }}
        >
          <Button
            onClick={handleOpenAgregarTanque}
            variant="contained"
            size="small"
            startIcon={<AddBoxTwoToneIcon />}
            sx={{
              ml: 5,
              height: 38,
              borderRadius: 4,
              backgroundColor: "#1E88E5",
              border: "2px solid white",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#1976D2", // hover
              },
            }}
          >
            Nuevo Tanque
          </Button>

          {/* Tabs centradas */}
          <Tabs
            value={value}
            onChange={handleChange}
            textColor="inherit"
            sx={{
              flex: 1,
              justifyContent: "center",
              "& .MuiTabs-flexContainer": {
                justifyContent: "center",
              },
              "& .MuiTab-root": {
                color: "#fff",
                textTransform: "none",
                fontWeight: 500,
                minWidth: 150,
              },
              "& .Mui-selected": {
                color: "#fff",
                fontWeight: "bold",
              },
              "& .MuiTabs-indicator": {
                height: 4,
                borderRadius: 2,
                backgroundColor: "#EAEFF1",
              },
            }}
          >
            <Tab
              icon={<PropaneIcon fontSize="small" />}
              iconPosition="start"
              label="Disponibles para Instalar"
              sx={{ minHeight: 40, py: 2, px: 3 }}
            />
            <Tab
              icon={<CheckCircleIcon fontSize="small" />}
              iconPosition="start"
              label="Asignados"
              sx={{ minHeight: 40, py: 2, px: 3 }}
            />
            <Tab
              icon={<DirectionsCarIcon fontSize="small" />}
              iconPosition="start"
              label="Autoelevadores"
              sx={{ minHeight: 40, py: 2, px: 3 }}
            />
            <Tab
              icon={<PendingIcon fontSize="small" />}
              iconPosition="start"
              label="Otros"
              sx={{ minHeight: 40, py: 2, px: 3 }}
            />
          </Tabs>
        </Box>
      </Paper>

      <Box sx={{ p: 2 }}>
        {value === 0 && (
          <DisponiblesParaInstalar refreshKey={refreshDisponiblesKey} />
        )}
        {value === 1 && <Tanques />}
        {value === 2 && <Autoelevadores />}
        {value === 3 && <OtrosTanques />}
      </Box>

      {/* AGREGAR TANQUE */}
      <Dialog
        fullWidth
        maxWidth={"lg"}
        open={dialogAgregar}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            // Al presionar ESCAPE o Click a la zona sin dialog no hace nada, evita el cierre del diálogo
          } else {
            handleCloseAgregarTanque(event, reason);
          }
        }}
      >
        <Addtanque
          handleCloseAgregarTanque={handleCloseAgregarTanque}
          onTanqueGuardado={handleTanqueGuardado}
        />
      </Dialog>
    </>
  );
}

export default TabsTanques;
